var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Track inventory')},model:{value:(_vm.track),callback:function ($$v) {_vm.track=$$v},expression:"track"}})}
var staticRenderFns = []

export { render, staticRenderFns }